import {noop} from 'lodash';
import React, {FC} from 'react';

import {
  CrmSyncIntegrationResourceTypesEnum,
  CrmSyncSourcesEnum,
} from '../../../../../../../../../src/models/api/crmSyncModel';
import {SectionDividerDiv} from '../crmSyncsForm';
import {useCrmPageConfig} from '../crmSyncsPageConfig/crmSyncsPageConfig';
import {CrmSyncsSectionHeader} from '../crmSyncsSectionHeader';

/*
 * Props.
 */

export interface CrmSyncsPlaceholderFormProps {
  source: CrmSyncSourcesEnum;
}

/*
 * Component.
 */

export const CrmSyncsPlaceholderForm: FC<CrmSyncsPlaceholderFormProps> = ({source}) => {
  const {account, card} = useCrmPageConfig(source);
  return (
    <>
      {account && (
        <>
          <SectionDividerDiv />
          <CrmSyncsSectionHeader
            source={source}
            resourceType={CrmSyncIntegrationResourceTypesEnum.ACCOUNT}
            isEnabled={false}
            isAdmin={false}
            isChangeDisabled
            onChange={noop}
          />
          <SectionDividerDiv />
        </>
      )}
      {card && (
        <>
          {!account && <SectionDividerDiv />}
          <CrmSyncsSectionHeader
            source={source}
            resourceType={CrmSyncIntegrationResourceTypesEnum.CARD}
            isEnabled={false}
            isAdmin={false}
            isChangeDisabled
            onChange={noop}
          />
          <SectionDividerDiv />
        </>
      )}
    </>
  );
};
